/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TenantIdMessengerIdHostConfigLauncherLayoutImport } from './routes/$tenantId/$messengerId/$hostConfig/_launcherLayout'
import { Route as TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutImport } from './routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout'
import { Route as TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport } from './routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout'

// Create Virtual Routes

const TenantIdMessengerIdHostConfigImport = createFileRoute(
  '/$tenantId/$messengerId/$hostConfig',
)()
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleImport = createFileRoute(
  '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale',
)()
const TenantIdMessengerIdHostConfigLauncherLayoutIndexLazyImport =
  createFileRoute('/$tenantId/$messengerId/$hostConfig/_launcherLayout/')()
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLoginIndexLazyImport =
  createFileRoute(
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/login/',
  )()
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLauncherIndexLazyImport =
  createFileRoute(
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/launcher/',
  )()
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutNewsIndexLazyImport =
  createFileRoute(
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/news/',
  )()
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIndexLazyImport =
  createFileRoute(
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/',
  )()
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutLauncherAuthIndexLazyImport =
  createFileRoute(
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/launcherAuth/',
  )()
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHomeIndexLazyImport =
  createFileRoute(
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/home/',
  )()
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpIndexLazyImport =
  createFileRoute(
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/',
  )()
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesNewIndexLazyImport =
  createFileRoute(
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/new/',
  )()
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIdIndexLazyImport =
  createFileRoute(
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/$id/',
  )()
const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpTypeIdIndexLazyImport =
  createFileRoute(
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/$type/$id/',
  )()

// Create/Update Routes

const TenantIdMessengerIdHostConfigRoute =
  TenantIdMessengerIdHostConfigImport.update({
    path: '/$tenantId/$messengerId/$hostConfig',
    getParentRoute: () => rootRoute,
  } as any)

const TenantIdMessengerIdHostConfigLauncherLayoutRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutImport.update({
    id: '/_launcherLayout',
    getParentRoute: () => TenantIdMessengerIdHostConfigRoute,
  } as any)

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleImport.update({
    path: '/$locale',
    getParentRoute: () => TenantIdMessengerIdHostConfigLauncherLayoutRoute,
  } as any)

const TenantIdMessengerIdHostConfigLauncherLayoutIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutIndexLazyImport.update({
    path: '/',
    getParentRoute: () => TenantIdMessengerIdHostConfigLauncherLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/index.lazy'
    ).then((d) => d.Route),
  )

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutImport.update({
    id: '/_localeLayout',
    getParentRoute: () =>
      TenantIdMessengerIdHostConfigLauncherLayoutLocaleRoute,
  } as any)

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport.update(
    {
      id: '/_tabsLayout',
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRoute,
    } as any,
  )

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLoginIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLoginIndexLazyImport.update(
    {
      path: '/login/',
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/login/index.lazy'
    ).then((d) => d.Route),
  )

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLauncherIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLauncherIndexLazyImport.update(
    {
      path: '/launcher/',
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/launcher/index.lazy'
    ).then((d) => d.Route),
  )

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutNewsIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutNewsIndexLazyImport.update(
    {
      path: '/news/',
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/news/index.lazy'
    ).then((d) => d.Route),
  )

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIndexLazyImport.update(
    {
      path: '/messages/',
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/index.lazy'
    ).then((d) => d.Route),
  )

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutLauncherAuthIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutLauncherAuthIndexLazyImport.update(
    {
      path: '/launcherAuth/',
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/launcherAuth/index.lazy'
    ).then((d) => d.Route),
  )

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHomeIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHomeIndexLazyImport.update(
    {
      path: '/home/',
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/home/index.lazy'
    ).then((d) => d.Route),
  )

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpIndexLazyImport.update(
    {
      path: '/help/',
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/index.lazy'
    ).then((d) => d.Route),
  )

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesNewIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesNewIndexLazyImport.update(
    {
      path: '/messages/new/',
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/new/index.lazy'
    ).then((d) => d.Route),
  )

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIdIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIdIndexLazyImport.update(
    {
      path: '/messages/$id/',
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/$id/index.lazy'
    ).then((d) => d.Route),
  )

const TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpTypeIdIndexLazyRoute =
  TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpTypeIdIndexLazyImport.update(
    {
      path: '/help/$type/$id/',
      getParentRoute: () =>
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/$type/$id/index.lazy'
    ).then((d) => d.Route),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$tenantId/$messengerId/$hostConfig': {
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigImport
      parentRoute: typeof rootRoute
    }
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout': {
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutImport
      parentRoute: typeof TenantIdMessengerIdHostConfigRoute
    }
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/': {
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutIndexLazyImport
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutImport
    }
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale': {
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleImport
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutImport
    }
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout': {
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutImport
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleRoute
    }
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout': {
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutImport
    }
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/launcher/': {
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLauncherIndexLazyImport
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutImport
    }
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/login/': {
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLoginIndexLazyImport
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutImport
    }
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/': {
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpIndexLazyImport
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport
    }
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/home/': {
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHomeIndexLazyImport
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport
    }
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/launcherAuth/': {
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutLauncherAuthIndexLazyImport
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport
    }
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/': {
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIndexLazyImport
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport
    }
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/news/': {
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutNewsIndexLazyImport
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport
    }
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/$id/': {
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIdIndexLazyImport
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport
    }
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/messages/new/': {
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesNewIndexLazyImport
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport
    }
    '/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout/help/$type/$id/': {
      preLoaderRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpTypeIdIndexLazyImport
      parentRoute: typeof TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  TenantIdMessengerIdHostConfigRoute.addChildren([
    TenantIdMessengerIdHostConfigLauncherLayoutRoute.addChildren([
      TenantIdMessengerIdHostConfigLauncherLayoutIndexLazyRoute,
      TenantIdMessengerIdHostConfigLauncherLayoutLocaleRoute.addChildren([
        TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutRoute.addChildren(
          [
            TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutRoute.addChildren(
              [
                TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpIndexLazyRoute,
                TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHomeIndexLazyRoute,
                TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutLauncherAuthIndexLazyRoute,
                TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIndexLazyRoute,
                TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutNewsIndexLazyRoute,
                TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesIdIndexLazyRoute,
                TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutMessagesNewIndexLazyRoute,
                TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutTabsLayoutHelpTypeIdIndexLazyRoute,
              ],
            ),
            TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLauncherIndexLazyRoute,
            TenantIdMessengerIdHostConfigLauncherLayoutLocaleLocaleLayoutLoginIndexLazyRoute,
          ],
        ),
      ]),
    ]),
  ]),
])

/* prettier-ignore-end */
